import { Avatar } from "@circleco/compass/components/Avatar";
import { Typography } from "@circleco/compass/components/Typography";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { t } from "@/i18n-js/instance";

interface ProfileMenuTriggerProps extends ComponentPropsWithoutRef<"button"> {
  avatarUrl?: string;
  name: string;
  showName?: boolean;
}

export const ProfileMenuTrigger = forwardRef<
  HTMLButtonElement,
  ProfileMenuTriggerProps
>(({ avatarUrl, name, showName = true, ...props }, ref) => (
  <button
    ref={ref}
    type="button"
    aria-label={t("user_menu_options")}
    className="hover:bg-tertiary focus-visible:outline-secondary flex min-w-0 items-center gap-2 rounded-md px-2 py-1 transition-colors focus-visible:outline focus-visible:outline-2 h-9"
    {...props}
  >
    <Avatar name={name} src={avatarUrl} size="xs" />
    {showName && (
      <Typography variant="body-sm" color="primary" truncate>
        {name}
      </Typography>
    )}
  </button>
));

ProfileMenuTrigger.displayName = "ProfileMenuTrigger";
